import styled from "styled-components/macro";
import Modal from "./../Modal/index";
import { ModalContext } from "../../../context/ModalContext";
import { useContext } from "react";
import Cross from "./../Icons/Cross";
import { useHistory } from "react-router-dom";
import { linkBase } from "./../Link/index";
import event from "./../../../images/modal-events.svg";
import post from "./../../../images/modal-post.svg";
import attraction from "./../../../images/modal-frame.svg";

const Base = styled.div`
  width: 527px;
  height: 414px;
  background-color: #fff;
  position: relative;

  div {
    width: 75%;
    margin: 2.5rem auto;
  }
`;

const CloseButton = styled.button`
  background: #fff;
  border: none;
  position: absolute;
  top: 25px;
  right: 25px;
`;

const Heading = styled.h3`
  font-size: 1.75rem;
  font-weight: 600;
  text-align: center;
  margin-top: 3.3rem;
`;

const ModalLink = styled.a`
  ${linkBase}
  padding: 0.75rem 50px 0.75rem 0;
  display: block;
  margin-bottom: 1.2rem;
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  background-color: ${({ theme }) => theme.colors.indigo};
  display: flex;
  justify-content: start;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: #fff;
  }

  & span:first-child {
    background-color: rgba(255, 255, 255, 0.6);
    padding: 3px 7px;
    border-radius: ${({ theme }) => theme.borderRadius.xl};
    margin-left: 27px;
  }

  & span:last-child {
    width: 100%;
    text-align: center;
  }
`;

const links = [
  { title: "Add new post", route: "/create-post", img: post },
  { title: "Add new event", route: "/create-event", img: event },
  { title: "Add new attraction", route: "/attractions", img: attraction },
];

export default function AddShortcutModal() {
  const history = useHistory();

  const { showAddShortcutModal, setShowAddShortcutModal } =
    useContext(ModalContext);

  const handleRedirect = (route) => {
    history.push(route);
    setShowAddShortcutModal(false);
  };

  return (
    <Modal
      show={showAddShortcutModal}
      onClose={() => setShowAddShortcutModal(false)}
    >
      <Base>
        <CloseButton onClick={() => setShowAddShortcutModal(false)}>
          <Cross fill={"#161F3D"} h="19" w="19" />
        </CloseButton>

        <Heading>Add</Heading>

        <div>
          {links.map((link) => (
            <ModalLink
              key={link.title}
              onClick={() => handleRedirect(link.route)}
            >
              <span>
                <img src={link.img} alt="" />
              </span>
              <span>{link.title}</span>
            </ModalLink>
          ))}
        </div>
      </Base>
    </Modal>
  );
}
